var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer_img"},[_c('img',{attrs:{"src":"images/footer.png","alt":""}})]),_c('div',{staticClass:"footer_txt"},[_vm._v("IL GIOCO E' VIETATO AI MINORI"),_c('br'),_vm._v("E PUÒ CAUSARE DIPENDENZA PATOLOGICA")])])])
}]

export { render, staticRenderFns }